import { useEffect, useState } from "react";

import { emailValidation } from "../../../utils/helper";

interface EmailValidationProps {
  email: string;
}

const useEmailValidation = (props: EmailValidationProps) => {
  const { email } = props;

  const [error, setError] = useState<string>("");

  const validateEmail = (value: string) => {
    setError(emailValidation(value, 2, 50));
  };

  useEffect(() => {
    validateEmail(email);
  }, [email]);

  return error;
};

export default useEmailValidation;
